import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterModal
Description : Se definen los estilos de los elementos del resto del formulario
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen estilos y elementos del formulario
================================================================================ */

export const FormGroup = styled.div`
    color: #3498DB;
    width: 40%;
    height: 30px;
    margin-bottom: 3em;
    margin-right: 2em;
    display: flex;
    flex-direction: column;
    /* margin: 50px; */
    /* margin-top: -5px; */
     @media screen and (max-width: 960px){
        width: 70%;
    }
`;

export const Form = styled.form`
`;

export const Forms = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    @media screen and (max-width: 960px){
        /* width: 100%; */
        /* padding-left: 1.5rem */
    }

`

export const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    //height: 10vh;
     @media screen and (max-width: 960px){
        flex-direction: column;
        /* width: 80%; */
    }
`

export const Button = styled.button`
    margin-bottom: 0px;
    margin-top: 30px;
`;

export const Label = styled.label`
	color: #3498DB;
    display: flex;
    margin-top: -5px;
    /* justify-content: flex-start; */
    margin-bottom: 5px;
    font-size: 14px;
    text-align: left;
    width: 100%;
     @media screen and (max-width: 767px){
        width: 150%
        /* width: 80%; */
    }
`;

export const Input = styled.input`
	padding: 0.5em;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
    border: 1px solid;
    border-color: #3498DB;
`;

export const H2 = styled.h2`
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    z-index: 1;
    &:before {
        border-top: 1px solid #1061a2;
        content: "";
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 75%;
        z-index: -1;
    };
`;

export const Span = styled.span`
    background: #fff;
    padding: 0;
`;

export const Select2 = styled.select`
    padding: 0.5em;
    width:100%;
    margin-top: -3px;
    margin-bottom: 2px;

    option {
        display: flex;
        white-space: pre;
        min-height: 20px;
        padding: 0px 2px 1px;
      }
`;

export const DeletedButton = styled.div`
    button{
        display: none;
    }
`;